import React, { useEffect } from 'react';
import { useForm, UseFormProps } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Stack, Typography } from '@mui/material';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { ModalOutProps } from 'new/routes/ModalDefault';
import { ModalComponent } from 'new/routes/RouterManager';
import styles from './ModalAddDomain.module.scss';
import { TextField } from 'new/elements/TextField';
import { addDomain, loadAllDomains } from 'js/actions';
import { showAlert } from 'new/stores/showAlert/action';
import { useModals } from 'new/hooks/useModals';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { ADD_DOMAIN_REQUEST } from 'js/constants/actionTypes';
import useDidUpdateEffect from 'new/hooks/useDidUpdateEffect';

interface ModalAddDomainProps {}

type InputKeys = 'name';

const useFormInitialProps = {
  mode: 'onChange',
  defaultValues: { name: '' },
} as UseFormProps<any>;

export const ModalAddDomain: ModalComponent = (props: ModalAddDomainProps & ModalOutProps) => {
  const { setModalActions, setLoading } = props;
  const dispatch = useDispatch<ThunkDispatch<any, any, Action>>();
  const { closeModal } = useModals();
  const isLoading = useIsLoading(ADD_DOMAIN_REQUEST);
  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(useFormInitialProps);
  const name = watch().name;

  useEffect(() => {
    setModalActions({
      ok: {
        text: 'Create',
        onClick: handleSubmit(onSubmit),
        disabled: name === '',
      },
    });
  }, [name, errors]);

  useDidUpdateEffect(() => {
    setLoading(isLoading);
  }, [isLoading]);

  const getRegister = (key: InputKeys) => ({
    ...register(key, { required: `You need to set a ${key}` }),
  });

  const onSubmit = (data) => {
    dispatch(addDomain(data.name)).then(() => {
      dispatch(
        showAlert({
          title: `Domain "${data.name}" added successfully`,
          severity: 'success',
        }),
      );
      dispatch(loadAllDomains());
      closeModal(ModalAddDomain.modalConfig.name);
    });
  };

  return (
    <Stack gap="8px">
      <TextField
        name="name"
        className={styles.domainNameInput}
        label="Name"
        placeholder="Enter a name"
        {...getRegister('name')}
      />
      <Typography variant="body2" className={styles.fieldSubText}>
        Create a unique name for this Data Domain.
      </Typography>
    </Stack>
  );
};

ModalAddDomain.modalConfig = {
  name: 'ModalAddDomain',
  title: 'New Data Domain',
  rootClassName: styles.rootModalContainer,
  contentClassName: styles.contentModalContainer,
  fullWidth: true,
  maxWidth: 'sm',
};
